import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import { useProvider } from '../../context/MenuProvider';

const Footer = () => {
  const { crudAdmin, hasPerms, atalhos } = useProvider();
  const { loading } = crudAdmin || {};

  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 992); // bootstrap lg breakpoint

  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth >= 992);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  
  
  

  const menuItems = parseInt(atalhos?.fother?.length || 0) >0 ? atalhos?.fother : [
    { path: "/painel/", icone: "bx bx-home-alt-2", nome_curto: "Início", perms: null, ativo:true },
    
    { path: "/clientes", icone: "bx bx-group", nome_curto: "Clientes", perms: ["loja.view_clientes",], ativo:true },
    { path: "/vendas", icone: "bx bx-basket", nome_curto: "Vendas", perms: ["loja.view_venda",], ativo:true },
    { path: "/pagamentos/despesa/negocio,pessoais", icone: "bx bx-wallet-alt", nome_curto: "Despesas", perms: ["financas.view_financeiro",], ativo:true },
    { path: "/pagamentos", icone: "bx bx-dollar", nome_curto: "Pagamentos", perms: ["loja.view_pagamento",], ativo:true },
    { path: "/agenda", icone: "bx bx-calendar", nome_curto: "Agenda", perms: ["loja.view_agenda",], ativo:true },
    { path: "/painel/apresentacoes", icone: "bx bx-slideshow", nome_curto: "Slide", perms: ['rede.add_apresentacao'], ativo:true },
    { path: "/rede/apn", icone: "bx bx-book-reader", nome_curto: "APN", perms: ["rede.view_apn",], ativo:true },
    { path: "/rede/equipe", icone: "bx bx-sitemap", nome_curto: "Equipe", perms: ["rede.view_consultor",], ativo:true },
    { path: "/rede/prospectos", icone: "bx bx-id-card", nome_curto: "Contatos", perms: ["rede.view_prospecto",], ativo:true },

    { path: "/painel/loja", icone: "bx bx-tachometer", nome_curto: "Loja", perms: ['catalogo_publico'], ativo:true },
    
    
    { path: "/config", icone: "bx bx-cog", nome_curto: "Config", perms: null, ativo:true },
    { path: "/painel/perfil", icone: "bx bx-user", nome_curto: "Perfil", perms: null, ativo:true},
  ];

  const filteredItems = menuItems.filter(item => (!item.perms?.length || hasPerms(item.perms)) && item.ativo);
  
  // se desktop mostra 7, senão 4

  const permsGestao = [
      //vendas
      "loja.view_produtos",
      "loja.view_clientes",
      //rede
      "rede.view_apn",
      "rede.view_prospecto",
      "rede.view_consultor",
      //financas
      "financas.view_financeiro",
  ]
  const limitedItems = filteredItems.slice(0, isDesktop ? 7 : !atalhos?.fother?.length && hasPerms(permsGestao)?3:4);
  if (parseInt(atalhos?.fother?.length || 0)===0){
    limitedItems.push({ path: "/painel/gestao", icone: "bx bx-briefcase", nome_curto: "Gestão", perms: permsGestao, ativo:true });
  } 

  return (
    <nav className="navbar navbar-light fixed-bottom shadow">
      <div id="menuRodape" className="container text-center">
        {limitedItems.map((item, index) => (
          <Link key={index} to={item.path} className="navbar-toggler">
            <i className={item.icone}></i>
            <div>{item.nome_curto}</div>
          </Link>
        ))}
      </div>
    </nav>
  );
};

export default Footer;